import * as React from "react";
import styles from "./SideNavLink.module.scss";
import { useHref, useMatch, useNavigate } from "react-router-dom";
import { mergeClasses as css, makeStyles } from "@fluentui/react-components";
import { FluentIcon } from "@fluentui/react-icons/lib/utils/createFluentIcon";

import { tokens } from "@fluentui/react-theme";

const useStyles = makeStyles({
	activeLink: {
		boxShadow: tokens.shadow4,
	},
	linkInner: {},
});
export interface ISideNavLinkProps {
	icon: FluentIcon;
	label: string;
	path: string;
}

export function SideNavLink(props: ISideNavLinkProps) {
	const classes = useStyles();

	const href = useHref(props.path, { relative: "route" });
	const match = useMatch(href);
	const isMatch = React.useMemo(() => {
		return !!props.path && !!match;
	}, [match, props.path]);
	const nav = useNavigate();

	return (
		<div
			className={css(styles.sideNavLink, isMatch && styles.active, isMatch && classes.activeLink)}>
			<a
				href={href}
				onClick={(ev) => {
					ev.preventDefault();
					if (ev.ctrlKey) {
						window.open(href, "_blank");
					} else {
						nav(href);
					}
				}}>
				<div className={css(styles.linkInner, classes.linkInner)}>
					<div className={styles.icon}>{<props.icon />}</div>
					<div className={styles.label}>{props.label}</div>
				</div>
			</a>
		</div>
	);
}
